// extracted by mini-css-extract-plugin
export default {"imageWrapper":"fP-z","hovered":"gP-z","hoverImage":"hP-z","mainImage":"iP-z","imageNoBackground":"jP-z","fullSizeImage":"kP-z"};